"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GenomeVisualizer_1 = require("../GenomeVisualizer");
var InternalDataSource = /** @class */ (function () {
    function InternalDataSource(dataSource) {
        this.dataSource = dataSource;
        this.tileCaches = {};
        this.localContigs = new Array();
    }
    InternalDataSource.prototype.getContigs = function () {
        var _this = this;
        return this.dataSource.getContigs()
            .then(function (contigs) { return _this.cachedContigs = contigs; })
            .then(function (contigs) { return contigs.concat(_this.localContigs); });
    };
    InternalDataSource.prototype.getCachedContigs = function () {
        return this.cachedContigs.concat(this.localContigs);
    };
    InternalDataSource.prototype.addContig = function (contig) {
        var existingContig = this.localContigs.find(function (c) { return c.id === contig.id; });
        if (existingContig == null) {
            this.localContigs.push(contig);
        }
        else {
            // expand existing contig
            existingContig.startIndex = Math.min(existingContig.startIndex, contig.startIndex);
            existingContig.span = Math.min(existingContig.span, contig.span);
            existingContig.name = existingContig.name || contig.name;
        }
        // tileLoaders that have already been cached might need to update their maxX
        for (var type in this.tileCaches) {
            for (var tileLoaderContig in this.tileCaches[type]) {
                var tileLoader = this.tileCaches[type][tileLoaderContig];
                if (tileLoader.contig === contig.id) {
                    var maxX = contig.startIndex + contig.span;
                    if (isFinite(tileLoader.maximumX)) {
                        tileLoader.maximumX = Math.max(maxX, tileLoader.maximumX);
                    }
                    else {
                        tileLoader.maximumX = maxX;
                    }
                }
            }
        }
    };
    InternalDataSource.prototype.removeContig = function (contig) {
        var i = this.localContigs.length - 1;
        while (i >= 0) {
            this.localContigs[i].id === contig.id;
            this.localContigs.splice(i, 1);
            i--;
        }
    };
    InternalDataSource.prototype.getTileLoader = function (model, contig) {
        var type = model.type;
        var key = contig;
        var trackTypeDescriptor = GenomeVisualizer_1.GenomeVisualizer.getTrackType(type);
        var differentiatingKey = trackTypeDescriptor.tileLoaderClass.cacheKey(model);
        if (differentiatingKey != null) {
            key += '\x1f' + differentiatingKey;
        }
        var tileCaches = this.tileCaches[type];
        if (tileCaches === undefined) {
            this.tileCaches[type] = tileCaches = {};
        }
        var tileLoader = tileCaches[key];
        if (tileLoader === undefined) {
            tileCaches[key] = tileLoader = new trackTypeDescriptor.tileLoaderClass(this.dataSource, model, contig);
            // set maximumX when we have access to contig info
            this.getContigs().then(function (contigInfoArray) {
                var matchingContigInfo = contigInfoArray.find(function (c) { return c.id === contig; });
                if (matchingContigInfo != null) {
                    var maxX = matchingContigInfo.startIndex + matchingContigInfo.span;
                    if (isFinite(tileLoader.maximumX)) {
                        tileLoader.maximumX = Math.max(maxX, tileLoader.maximumX);
                    }
                    else {
                        tileLoader.maximumX = maxX;
                    }
                }
            });
        }
        return tileLoader;
    };
    InternalDataSource.prototype.clearTileCache = function (type) {
        var tileCaches = this.tileCaches[type];
        if (tileCaches === undefined)
            return;
        for (var key in tileCaches) {
            var tileCache = tileCaches[key];
            tileCache.clear();
        }
        delete this.tileCaches[type];
    };
    InternalDataSource.prototype.clearTileCaches = function () {
        for (var type in this.tileCaches) {
            this.clearTileCache(type);
        }
    };
    return InternalDataSource;
}());
exports.InternalDataSource = InternalDataSource;
exports.default = InternalDataSource;
